<script>
/**
 * Index component
 */
export default {};
</script>
<template>
  <div>
    <Navbar />

    <div
      v-scroll-spy="{
        sectionSelector: '.section',
        offset: 450
      }"
    >
      <!--START HOME-->
      <section
        class="section bg-home height-100vh"
        id="home"
        :style="{
          'background-image':
            'url(' + require('@/assets/images/img-1.jpg') + ')',
          'background-size': 'cover',
          'background-position': 'center'
        }"
      >
        <div class="bg-overlay"></div>
        <div class>
          <div class>
            <div class="container slidero">
              <div class="row">
                <div class="col-lg-8 offset-lg-2 text-white text-center">
                  <h1 class="home-title">
                    404
                  </h1>
                  <h2 class="padding-t-15 home-desc mx-auto">
                    The page you are looking for could not be found!
                  </h2>
                  <router-link to="/" class="btn btn-bg-white margin-t-30"
                    >Go Home</router-link
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Particles -->
      </section>
      <!--END HOME-->
    </div>
  </div>
</template>

<style scoped>
::v-deep .modal-content {
  background-color: #000000;
  color: white;
  background: none;
  border: none;
}
::v-deep .modal-header {
  border: none;
}
::v-deep .modal-backdrop {
  opacity: 0.5;
}
.home-title {
  font-size: 8rem;
}
.home-desc {
  padding-top: 40px;
  font-size: 20px;
  font-weight: 100;
}
</style>